package ir.yusefpasha.style

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.hover
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val PortfolioSectionStyle by ComponentStyle {
    cssRule(" > #columnParent > #boxParent > #greenOverlay") {
        Modifier.width(0.px).transition(CSSTransition(property = "width", duration = Constants.ANIMATION_DURATION))
    }

    cssRule(":hover > #columnParent > #boxParent > #greenOverlay") {
        Modifier.width(300.px).transition(CSSTransition(property = "width", duration = Constants.ANIMATION_DURATION))
    }


    cssRule(" > #columnParent > #boxParent > #greenOverlay > #linkIcon") {
        Modifier.visibility(Visibility.Hidden)
    }

    cssRule(":hover > #columnParent > #boxParent > #greenOverlay > #linkIcon") {
        Modifier.visibility(Visibility.Visible)
    }


    cssRule(" > #columnParent > #portfolioTitle") {
        Modifier
            .color(Theme.Secondary.rgb)
            .translateX(0.percent)
            .transition(
                CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION),
                CSSTransition(property = "translate", duration = Constants.ANIMATION_DURATION)
            )
    }

    cssRule(":hover > #columnParent > #portfolioTitle") {
        Modifier
            .color(Theme.Primary.rgb)
            .translateX(5.percent)
            .transition(
                CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION),
                CSSTransition(property = "translate", duration = Constants.ANIMATION_DURATION)
            )
    }

    cssRule(" > #columnParent > #portfolioDesc") {
        Modifier
            .translateX(0.percent)
            .transition(
                CSSTransition(property = "translate", duration = Constants.ANIMATION_DURATION)
            )
    }

    cssRule(":hover > #columnParent > #portfolioDesc") {
        Modifier
            .translateX(5.percent)
            .transition(
                CSSTransition(property = "translate", duration = Constants.ANIMATION_DURATION)
            )
    }
}

val PortfolioArrowIconStyle by ComponentStyle {
    base {
        Modifier.color(Theme.Gray.rgb)
            .transition(CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION))
    }

    hover {
        Modifier.color(Theme.Primary.rgb)
            .transition(CSSTransition(property = "color", duration = Constants.ANIMATION_DURATION))
    }
}